import ObjectsData from '../Data/Objects.js';

export default class Maps {
    content = ''
    lines = []
    shelves = []
    objects = []
    dimensions = {
        width: 0,
        depth: 0
    }

    constructor(text) {
        this.dataObject = new ObjectsData()
        this.objects_legend = this.dataObject.getObjects()
        this.content = text
        this.defineMapDimensions()
        this.parseFile()
    }

    defineMapDimensions() {
        // Get entrepot size from maps
        let array_content = this.content.split(/\r\n|\n/)
        this.dimensions.depth = array_content.length
        // Get longest line to define width
        let longest_line = array_content.reduce((a, b) => a.length > b.length ? a : b)
        this.dimensions.width = longest_line.length
    }

    parseFile() {
        // Explode each line into an array of arrays
        this.lines = this.content.split(/\r\n|\n/).map(line => line.split(''))
        this.createShelves('horizontal')

        this.placeRandomObjects()

        // Change row into cols and cols into rows in order to get vertical shelves
        this.lines = this.lines[0].map((_, colIndex) => this.lines.map(row => row[colIndex]));
        this.createShelves('vertical')
    }

    /**
     * Place random objects on empty cases of the maps
     */
    placeRandomObjects() {
        // Get objects to place
        this.objects_legend.forEach(object => {

            // Dynamic objects
            if (!object.static) {
                // Get random number of objects to place
                let number_of_objects = Math.floor(Math.random() * (object.max - object.min + 1)) + object.min

                // Place objects
                for (let i = 0; i < number_of_objects; i++) {
                    // Get random position
                    let random_position = this.getRandomPosition()
                    // Place object
                    this.lines[random_position.x][random_position.z] = object.identifier
                }
            }
        })

        this.createObjects()
    }

    getRandomPosition() {
        let random_position = {
            x: Math.floor(Math.random() * this.dimensions.depth),
            z: Math.floor(Math.random() * this.dimensions.width)
        }

        // If position is not empty
        if (!this.isFreePosition(random_position.x, random_position.z)) {
            // Get new position
            return this.getRandomPosition()
        }

        return random_position
    }

    isFreePosition(x, z) {
        // Check if cell is empty and if all cells around are empty
        if (
            this.isSet(x, z) && this.lines[x][z] === ' ' &&
            this.isSet(x - 1, z) && this.lines[x - 1][z] === ' ' &&
            this.isSet(x + 1, z) && this.lines[x + 1][z] === ' ' &&
            this.isSet(x, z - 1) && this.lines[x][z - 1] === ' ' &&
            this.isSet(x, z + 1) && this.lines[x][z + 1] === ' '
        ) {
            return true
        }

        return false
    }

    isSet(x, z) {
        return typeof this.lines[x] !== 'undefined' && typeof this.lines[x][z] !== 'undefined'
    }

    createShelves(orientation) {
        this.lines.forEach((line, lineIndex) => {

            let start_shelf = false
            let shelf = []


            line.forEach((cell, cellIndex) => {
                // If cell is a letter
                if (this.isLetter(cell)) {
                    // If shelf not started
                    if (!start_shelf) {
                        start_shelf = true
                        shelf['position'] = {
                            x: orientation == 'horizontal' ? cellIndex : lineIndex,
                            z: orientation == 'horizontal' ? lineIndex : cellIndex
                        }
                        shelf['string'] = cell
                    }
                }

                // If the cell is a number
                if (this.isNumber(cell)) {
                    // If shelf started
                    if (start_shelf) {
                        shelf['string'] += cell
                    }
                }

                // If cell is a -
                if (cell === '-') {
                    // If shelf started
                    if (start_shelf) {
                        shelf['string'] += cell
                    }
                }

                // If the cell is a dot
                if (cell === '.') {
                    // End of the shelf
                    if (start_shelf) {
                        start_shelf = false
                        shelf['string'] += cell
                        shelf['end'] = [lineIndex, cellIndex]

                        // Add shelf to the array if it is valid
                        if (shelf['string'].length > 3) {
                            shelf['width'] = shelf['string'].length
                            shelf['orientation'] = orientation
                            shelf['code'] = shelf['string'].replace(/[-.]/gm, '')
                            this.shelves.push(shelf)
                        }

                        // Reset shelf
                        shelf = []
                    }
                }
            })
        })
    }

    createObjects() {
        this.lines.forEach((line, lineIndex) => {
            line.forEach((cell, cellIndex) => {
                if (this.dataObject.isObjectCharacter(cell)) {
                    let object = this.dataObject.getObjectFromIdentifier(cell)
                    this.objects.push({
                        name: object.name,
                        position: {
                            x: lineIndex,
                            z: cellIndex
                        }
                    })
                }
            })
        })
    }

    isLetter(str) {
        return str.length === 1 && str.match(/[a-z]/i);
    }

    isNumber(str) {
        return str.length === 1 && str.match(/[0-9]/i);
    }

    getShelves() {
        return {
            shelves: this.shelves,
            dimensions: this.dimensions,
            objects: this.objects
        }
    }
}